import React from 'react';
import PropTypes from 'prop-types';
import simplePortal from './simplePortal';

const container = document.querySelectorAll('.notification-banners-container .content-wrapper-inner')[0];

function Notifications({ show, onClickX, children, showX }) {
    if (show) {
        return (
            <div className="notification-banner animate banner-theme-icon">
                {children}
                {showX && (
                    <button className="icon icon-x" onClick={onClickX} aria-label="Close Notification" title="x" />
                )}
            </div>
        );
    }

    return null;
};

Notifications.propTypes = {
    show: PropTypes.bool.isRequired,
    onClickX: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired
}


export default simplePortal(Notifications, container);



// WEBPACK FOOTER //
// ./app/javascript/client/components/NotificationsPortal.jsx